import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify';

const baseUrlTra = process.env.REACT_APP_FACILITIES_MANAGEMENT;

export const getAllFacilities = createAsyncThunk('getAllFacilities', async (queryParams, { thunkAPI }) => {
    try {
        const { reqestQuery, isSearch } = queryParams;
        const response = await axios.get(`${baseUrlTra}/getAllFacilities`, {
            params: reqestQuery,
        });
        const { payload, next_cursor, has_next } = response.data;
        return {
            facilityList: payload.facility_organization_details,
            facilitiesAggregation: payload.facilities_aggregation,
            nextCursor: next_cursor,
            has_next: has_next,
            isSearch: isSearch,
        };
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});

export const createInvestorFacility = createAsyncThunk('createInvestorFacility', async (req, thunkAPI) => {
    const { data, dispatch } = req;
    try {
        const response = await axios.post(`${baseUrlTra}/facility`, data);

        const payload = response.data;

        if (payload) {
            toast.success(payload.serviceMessage, {
                icon: <span className='msg-icon float-start ms-2 sf-check success-icon'></span>,
            });

            setTimeout(() => {
                dispatch(getAllFacilities());
            }, 3000);
        }

        return payload;
    } catch (error) {
        const { response } = error;
        toast.error(response?.data?.serviceMessage ? response?.data?.serviceMessage : error.message);
        return thunkAPI.rejectWithValue(error);
    }
});

export const getAllBuyerOriganizations = createAsyncThunk('getAllBuyerOriganizations', async (thunkAPI) => {
    try {
        const response = await axios.get(`${baseUrlTra}/getAllOrganizationByRole/buyer`);
        const { payload } = response.data;
        return payload;
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});
export const getAllSupplierrOriganizations = createAsyncThunk('getAllSupplierrOriganizations', async (thunkAPI) => {
    try {
        const response = await axios.get(`${baseUrlTra}/getAllOrganizationByRole/supplier`);
        const { payload } = response.data;
        return payload;
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});

export const getFilteredBuyerSupplier = createAsyncThunk(
    'getFilteredBuyerSupplier',
    async (queryParams, { thunkAPI }) => {
        try {
            const formattedParams = [];

            Object.entries(queryParams).forEach(([key, value]) => {
                if (value !== undefined) {
                    if (Array.isArray(value) && value.length > 0) {
                        formattedParams.push(`${key}=${JSON.stringify(value.map((item) => encodeURIComponent(item)))}`);
                    } else {
                        formattedParams.push(`${key}=${encodeURIComponent(value)}`);
                    }
                }
            });

            const url = `${baseUrlTra}/getFilteredBuyerSupplier?${formattedParams.join('&')}`;

            const response = await axios.get(url);
            const { payload } = response.data;
            return payload;
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const getFacilityByID = createAsyncThunk('getFacilityByID', async (data, thunkAPI) => {
    const { ulid, facilityType, queryParams } = data;
    if (!ulid) {
        return thunkAPI.rejectWithValue(new Error('Facility ULID is required'));
    }
    try {
        const response = await axios.get(`${baseUrlTra}/getFacilityByID/${facilityType}/${ulid}`, {
            params: queryParams,
        });
        const { payload } = response.data;
        return payload;
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});

export const getDashboardDetailsByFacilityID = createAsyncThunk(
    'getDashboardDetailsByFacilityID',
    async (queryParams, { thunkAPI }) => {
        try {
            let graphInput = [
                { name: 'Jan', title: 'January', utilisation: 0 },
                { name: 'Feb', title: 'February', utilisation: 0 },
                { name: 'Mar', title: 'March', utilisation: 0 },
                { name: 'Apr', title: 'April', utilisation: 0 },
                { name: 'May', title: 'May', utilisation: 0 },
                { name: 'Jun', title: 'June', utilisation: 0 },
                { name: 'Jul', title: 'July', utilisation: 0 },
                { name: 'Aug', title: 'August', utilisation: 0 },
                { name: 'Sep', title: 'September', utilisation: 0 },
                { name: 'Oct', title: 'October', utilisation: 0 },
                { name: 'Nov', title: 'November', utilisation: 0 },
                { name: 'Dec', title: 'December', utilisation: 0 },
            ];

            const response = await axios.get(`${baseUrlTra}/getDashboardDetailsByFacilityID`, { params: queryParams });
            const { payload } = response.data;
            const { associated_buyers_suppliers, graph_data, underlying_invoices } = payload;

            if (Array.isArray(graph_data) && graph_data.length > 0) {
                graphInput.forEach((month) => {
                    const monthName = month.title.trim(); // Convert to lowercase and trim for case-insensitive matching
                    const secondArrayValue = graph_data.find((item) => item[monthName]);

                    if (secondArrayValue) {
                        month.utilisation = secondArrayValue[Object.keys(secondArrayValue)[0]];
                    }
                });
            }

            const investorDashboard = { associated_buyers_suppliers, graph: graphInput, underlying_invoices };
            return investorDashboard;
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);
export const getAllInvestorFacilityByOrgID = createAsyncThunk(
    'getAllInvestorFacilityByOrgID',
    async (queryParams, { thunkAPI }) => {
        try {
            const response = await axios.get(`${baseUrlTra}/getAllInvestorFacilityByOrgID`, { params: queryParams });
            const { payload } = response.data;
            return payload;
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);
export const getTransactionDetailsWithPagination = createAsyncThunk(
    'getTransactionDetailsWithPagination',
    async (req, thunkAPI) => {
        try {
            const response = await axios.post(`${baseUrlTra}/getTransactionDetailsWithPagination`, req);
            const resp = response.data;
            const { payload, has_next, next_cursor } = response.data;
            return { resp, payload, nextPage: { has_next, next_cursor } };
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const getLiveFacilityDetailsByID = createAsyncThunk(
    'getLiveFacilityDetailsByID',
    async (queryParams, { thunkAPI }) => {
        try {
            const response = await axios.get(`${baseUrlTra}/getLiveFacilityDetailsByID`, { params: queryParams });
            const { payload } = response.data;
            return payload;
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const getBuyerInsights = createAsyncThunk('getBuyerInsights', async (req, thunkAPI) => {
    try {
        const response = await axios.post(`${baseUrlTra}/getBuyerInsights`, req);
        const { payload } = response.data;
        return payload;
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});
export const getSupplierInsights = createAsyncThunk('getSupplierInsights', async (req, thunkAPI) => {
    try {
        const response = await axios.post(`${baseUrlTra}/getSupplierInsights`, req);
        const { payload } = response.data;
        return payload;
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});
export const getDocumentsByTransactionID = createAsyncThunk(
    'getDocumentsByTransactionID',
    async (queryParams, { thunkAPI }) => {
        try {
            const response = await axios.get(`${baseUrlTra}/getDocumentsByTransactionID`, { params: queryParams });
            const { payload } = response.data;
            return payload;
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);
export const getAllMasterInvestorFacilities = createAsyncThunk('getAllMasterInvestorFacilities', async (thunkAPI) => {
    try {
        const response = await axios.get(`${baseUrlTra}/masterInvestorFacilities`);
        const { payload } = response.data;
        return payload;
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});

export const updateMasterInvestorFacility = createAsyncThunk('updateMasterInvestorFacility', async (req, thunkAPI) => {
    try {
        const response = await axios.put(`${baseUrlTra}/updateMasterInvestorFacility/${req.id}`, req.payload, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        if (response) {
            toast.success(response.serviceMessage || response?.data?.serviceMessage, {
                icon: <i className='bi bi-check-circle-fill' style={{ color: '#409895' }}></i>,
            });
        }
        const payload = response.data;
        return payload;
    } catch (error) {
        const { response } = error;
        toast.error(response?.data?.serviceMessage ? response?.data?.serviceMessage : error.message);
        return thunkAPI.rejectWithValue(error);
    }
});
export const updateJuniorTrancheFacility = createAsyncThunk('updateJuniorTrancheFacility', async (req, thunkAPI) => {
    try {
        const response = await axios.put(`${baseUrlTra}/updateFacilityDetails`, req, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        if (response) {
            toast.success(response.serviceMessage || response?.data?.serviceMessage, {
                icon: <i className='bi bi-check-circle-fill' style={{ color: '#409895' }}></i>,
            });
        }
        const payload = response.data;
        return payload;
    } catch (error) {
        const { response } = error;
        toast.error(response?.data?.serviceMessage ? response?.data?.serviceMessage : error.message);
        return thunkAPI.rejectWithValue(error);
    }
});

export const updateFacilityDetails = createAsyncThunk('updateFacilityDetails', async (req, thunkAPI) => {
    try {
        const response = await axios.put(`${baseUrlTra}/updateFacilityDetails`, req, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        if (response) {
            toast.success(response.serviceMessage || response?.data?.serviceMessage, {
                icon: <i className='bi bi-check-circle-fill' style={{ color: '#409895' }}></i>,
            });
        }
        const payload = response.data;
        return payload;
    } catch (error) {
        const { response } = error;
        toast.error(response?.data?.serviceMessage ? response?.data?.serviceMessage : error.message);
        return thunkAPI.rejectWithValue(error);
    }
});

export const getTotalTransactionValues = createAsyncThunk(
    'getTotalTransactionValues',
    async (queryParams, { thunkAPI }) => {
        try {
            const response = await axios.get(`${baseUrlTra}/getTotalTransactionValues`, { params: queryParams });
            const { payload } = response.data;
            return payload;
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const getAllRecentEvents = createAsyncThunk('getAllRecentEvents', async (queryParams, { thunkAPI }) => {
    try {
        const response = await axios.get(`${baseUrlTra}/getRFQBidTransactionFacilitiesBorrowingsRecentEvents`, {
            params: queryParams,
        });
        const { payload } = response.data;
        return payload;
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});

export const getTotalYieldByID = createAsyncThunk('getTotalYieldByID', async (queryParams, { thunkAPI }) => {
    try {
        const response = await axios.get(`${baseUrlTra}/getTotalYieldByID`, { params: queryParams });
        const { payload } = response.data;
        return payload;
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});
export const getBuyersSuppliersMapData = createAsyncThunk('getBuyersSuppliersMapData', async (req, thunkAPI) => {
    try {
        const response = await axios.post(`${baseUrlTra}/getBuyersSuppliersMapData`, req);
        const { payload } = response.data;
        return payload;
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});
export const getBuyerSupplierInsightsMetrics = createAsyncThunk(
    'getBuyerSupplierInsightsMetrics',
    async (id, thunkAPI) => {
        try {
            const response = await axios.get(`${baseUrlTra}/getBuyerSupplierInsightsMetrics/${id}`);
            const { payload } = response.data;
            return payload;
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);
export const getAmountFundedTillDate = createAsyncThunk('getAmountFundedTillDate', async (id, thunkAPI) => {
    try {
        const response = await axios.get(`${baseUrlTra}/getAmountFundedTillDate/${id}`);
        const { payload } = response.data;
        return payload;
    } catch (error) {
        const errorMessage = error.response?.data?.serviceMessage || error.message;
        toast.error(errorMessage);
        return thunkAPI.rejectWithValue(errorMessage);
    }
});
export const getBuyerAverageCreditLimit = createAsyncThunk('getBuyerAverageCreditLimit', async (id, thunkAPI) => {
    try {
        const response = await axios.get(`${baseUrlTra}/getBuyerAverageCreditLimit`);
        const { payload } = response.data;
        return payload;
    } catch (error) {
        const errorMessage = error.response?.data?.serviceMessage || error.message;
        toast.error(errorMessage);
        return thunkAPI.rejectWithValue(errorMessage);
    }
});

export const getFacilityByOrgID = createAsyncThunk('getFacilityByOrgID', async (req, thunkAPI) => {
    try {
        const response = await axios.post(`${baseUrlTra}/getFacilityByOrgID`, req);
        const { payload } = response.data;
        return payload && payload[0];
    } catch (error) {
        const errorMessage = error.response?.data?.serviceMessage || error.message;
        toast.error(errorMessage);
        return thunkAPI.rejectWithValue(errorMessage);
    }
});
